/** The "CRM Intelligence" logo + wordmark, shared by the app header and the sign-in screen. */
export function BrandMark({
  iconHeight = 30,
  fontSizeClass = 'fs-4',
}: {
  iconHeight?: number;
  fontSizeClass?: string;
}) {
  return (
    <div className={`d-flex align-items-center gap-2 ${fontSizeClass}`}>
      <img height={iconHeight} src="/crm-intelligence-logo.svg" alt="CRM Intelligence" />
      <div>
        <span className="fw-bold">CRM</span>{' '}
        <span className="fw-medium text-muted">Intelligence</span>
      </div>
    </div>
  );
}
